/** Slugs for price-based browse collections (mirrors config/price-collections.json). */
export const PRICE_COLLECTION_SLUGS = new Set([
  'items-below-5',
  'items-between-5-and-10',
]);

export const PRICE_COLLECTION_TAGLINE =
  'Affordable finds without extra import charges';

export function isPriceCollectionSlug(slug) {
  return PRICE_COLLECTION_SLUGS.has((slug ?? '').toLowerCase());
}
